import React from 'react';
import { setView } from "../actions/index";
import { connect } from "react-redux";
import '../styles/Andra.scss';
import TranslationService from "../app/services/TranslationService";
import {config} from "../app/config";


const specialColors = {
    "de-de": ['343332', 'ff0000', 'ffcc00'],
    "et-ee": ['0072ce', '343332', 'ffffff'],
    "kk-kz": ['00afca', 'fec50c'],
    "pl-pl": ['e9e8e7', 'dc143c'],
    "ru-kz": ['00afca', 'fec50c'],
    "uk-ua": ['0057b7', 'ffdd00']
};

class WavingTriangleClass extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: Math.floor((Math.random() * 5000) + 2000),
            activeIcon: this.props.activeIcon !== undefined && this.props.activeIcon === true,
            colors: this.getColors()
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let colors = this.getColors();

        if (prevState.colors[0] !== colors[0]) {
            this.setState({colors: colors});
        }
    }

    getColors = () => {
        let colors = ['ff6400'];

        let nationalDays = TranslationService.trans(this.props.language, '_national_days');
        if (nationalDays !== '_national_days' && specialColors[this.props.language] !== undefined) {
            nationalDays = nationalDays.split(',');
            let date = new Date();
            let month = ((date.getUTCMonth() + 1) < 10 ? '0' + (date.getUTCMonth() + 1) : date.getUTCMonth() + 1);
            let today =
                month + '-' +
                (date.getUTCDate() < 10 ? '0' + date.getUTCDate() : date.getUTCDate());
            let currentDay = date.getUTCFullYear() + '-' + today;

            if (nationalDays.indexOf(today) >= 0 || nationalDays.indexOf(currentDay) >= 0) {
                colors = specialColors[this.props.language];
            }
        }

        if (config.special_colors !== null && specialColors[config.special_colors] !== undefined) {
            colors = specialColors[config.special_colors];
        }

        return colors;
    }

    getPathStyle = (color) => {
        return {
            fill: color,
            stroke: 'none',
            strokeWidth: '6'
        };
    }

    getTriangleStyle = (color) => {
        return {
            stroke: '#' + color,
            strokeWidth: this.props.hasOwnProperty('lines') ? this.props.lines : '2',
            strokeLinecap: 'round'
        };
    }

    render() {
        const index1 = 0;
        let index2 = 0;
        let index3 = 0;

        if (this.state.colors.length >= 2) {
            index2 = 1;
            index3 = 1;
        }

        if (this.state.colors.length === 3) {
            index3 = 2;
        }

        const firstMainColor = '#' + this.state.colors[index1] + '55';
        const firstSecondaryColor = '#' + this.state.colors[index1] + '33';

        const secondColorMixing = this.state.colors.length <= 2;
        const secondMainColor = '#' + this.state.colors[index2] + '77';
        const secondSecondaryColor = '#' + this.state.colors[secondColorMixing ? index1 : index2] + '55';

        const thirdMainColor = '#' + this.state.colors[index3] + '77';
        const thirdSecondaryColor = '#' + this.state.colors[index3] + '55';

        return (
            <div style={{width: this.props.size + 'px', height: this.props.size + 'px', display: 'block', margin: '0 auto 50px auto', textAlign: 'center', border: '0px solid yellow'}}>
                <svg
                    width="420"
                    height="420"
                    viewBox="0 0 111.125 111.125"
                    version="1.1"
                    id={'andra-glyph-' + this.state.id}
                    style={{width: this.props.size + 'px', height: this.props.size + 'px'}}
                >
                    <g id={'andra-glyph-path1-' + this.state.id}>
                        <path
                            d="M 2.6261946,30.74767 C 19.123838,38.468814 46.186723,36.318674 60.262305,15.471298 71.633021,-3.1890399 92.385063,6.8825964 108.45939,2.6278914"
                            style={this.getPathStyle(firstMainColor)}
                        >
                            <animate
                                attributeName="d"
                                values="
                                    M 2.6261946,30.74767 C 19.123838,38.468814 46.186723,36.318674 60.262305,15.471298 71.633021,-3.1890399 92.385063,6.8825964 108.45939,2.6278914;
                                    M 2.6821236,30.875557 C 4.7787726,23.888232 2.5610156,-5.930664 47.911013,18.938948 71.573356,31.849805 107.09365,5.7671694 108.51532,2.7557794;
                                    M 2.6261946,30.74767 C 19.123838,38.468814 46.186723,36.318674 60.262305,15.471298 71.633021,-3.1890399 92.385063,6.8825964 108.45939,2.6278914
                                "
                                dur="6s"
                                repeatCount="indefinite"
                                begin="0" />
                        </path>
                        <path
                            d="M 2.6821236,30.875557 C 4.7787726,23.888232 2.5610156,-5.930664 47.911013,18.938948 71.573356,31.849805 107.09365,5.7671694 108.51532,2.7557794"
                            style={this.getPathStyle(firstSecondaryColor)}
                        >
                            <animate
                                attributeName="d"
                                values="
                                    M 2.6821236,30.875557 C 4.7787726,23.888232 2.5610156,-5.930664 47.911013,18.938948 71.573356,31.849805 107.09365,5.7671694 108.51532,2.7557794;
                                    M 2.6261946,30.74767 C 19.123838,38.468814 46.186723,36.318674 60.262305,15.471298 71.633021,-3.1890399 92.385063,6.8825964 108.45939,2.6278914;
                                    M 2.6821236,30.875557 C 4.7787726,23.888232 2.5610156,-5.930664 47.911013,18.938948 71.573356,31.849805 107.09365,5.7671694 108.51532,2.7557794
                                "
                                dur="8s"
                                repeatCount="indefinite"
                                begin="0" />
                        </path>
                        <path
                            d="m 2.6279886,30.759721 c 0,0 5.3562594,-20.484894 37.8436164,-10.070231 c 60.661641,28.548442 75.779847,17.511361 79.297788,10.538649 84.537674,0.18389629 98.70603,5.2082724 108.45939,2.6278914"
                            style={this.getPathStyle(firstSecondaryColor)}
                        >
                            <animate
                                attributeName="d"
                                values="
                                    m 2.6279886,30.759721 c 0,0 5.3562594,-20.484894 37.8436164,-10.070231 C 60.661641,28.548442 75.779847,17.511361 79.297788,10.538649 84.537674,0.18389629 98.70603,5.2082724 108.45939,2.6278914;
                                    m 2.7540356,30.887612 c 0,0 27.2078644,19.757102 37.8436164,-10.070231 C 44.412428,11.053657 53.457749,-5.0059835 79.423835,10.66654 96.40031,20.311888 96.13605,7.991299 108.58544,2.7557834;
                                    m 2.6279886,30.759721 c 0,0 5.3562594,-20.484894 37.8436164,-10.070231 C 60.661641,28.548442 75.779847,17.511361 79.297788,10.538649 84.537674,0.18389629 98.70603,5.2082724 108.45939,2.6278914
                                "
                                dur="7s"
                                repeatCount="indefinite"
                                begin="0" />
                        </path>
                    </g>

                    <g id={'andra-glyph-path2-' + this.state.id}>
                        <path
                            d="M 108.45939,2.6278914 C 108.16113,50.821162 97.23053,83.881078 80.344437,108.46436"
                            style={this.getPathStyle(secondMainColor)}
                        >
                            <animate
                                attributeName="d"
                                values="
                                    M 108.45939,2.6278914 C 108.16113,50.821162 97.23053,83.881078 80.344437,108.46436;
                                    M 108.45939,2.6278874 C 105.88267,49.313396 68.793864,65.06324 80.344437,108.46436;
                                    M 108.45939,2.6278914 C 108.16113,50.821162 97.23053,83.881078 80.344437,108.46436
                                "
                                dur="6s"
                                repeatCount="indefinite"
                                begin="0" />
                        </path>
                        <path
                            d="M 108.45939,2.6278874 C 105.88267,49.313396 68.793864,65.06324 80.344437,108.46436"
                            style={this.getPathStyle(secondSecondaryColor)}
                        >
                            <animate
                                attributeName="d"
                                values="
                                    M 108.45939,2.6278874 C 105.88267,49.313396 68.793864,65.06324 80.344437,108.46436;
                                    M 108.45939,2.6278914 C 108.16113,50.821162 97.23053,83.881078 80.344437,108.46436;
                                    M 108.45939,2.6278874 C 105.88267,49.313396 68.793864,65.06324 80.344437,108.46436
                                "
                                dur="4s"
                                repeatCount="indefinite"
                                begin="0" />
                        </path>
                        <path
                            d="M 108.45939,2.6278914 C 90.148062,15.736592 79.832744,5.5528934 80.344444,108.46436"
                            style={this.getPathStyle(secondMainColor)}
                        >
                            <animate
                                attributeName="d"
                                values="
                                    M 108.45939,2.6278914 C 90.148062,15.736592 79.832744,5.5528934 80.344444,108.46436;
                                    M 108.45939,2.6278914 C 106.56226,72.336401 96.22803,100.99645 80.344443,108.46436;
                                    M 108.45939,2.6278914 C 90.148062,15.736592 79.832744,5.5528934 80.344444,108.46436
                                "
                                dur="7s"
                                repeatCount="indefinite"
                                begin="0" />
                        </path>
                    </g>

                    <g id={'andra-glyph-path3-' + this.state.id}>
                        <path
                            d="M 80.344442,108.46436 C 39.224761,94.86222 14.888674,67.750568 2.6821236,30.875556"
                            style={this.getPathStyle(thirdMainColor)}
                        >
                            <animate
                                attributeName="d"
                                values="
                                    M 80.344442,108.46436 C 39.224761,94.86222 14.888674,67.750568 2.6821236,30.875556;
                                    M 80.288513,108.33648 C 50.421468,63.548977 28.173847,30.649382 2.6261946,30.74767;
                                    M 80.344442,108.46436 C 39.224761,94.86222 14.888674,67.750568 2.6821236,30.875556
                                "
                                dur="6s"
                                repeatCount="indefinite"
                                begin="0" />
                        </path>
                        <path
                            d="M 80.288513,108.33648 C 50.421468,63.548977 28.173847,30.649382 2.6261946,30.74767"
                            style={this.getPathStyle(thirdSecondaryColor)}
                        >
                            <animate
                                attributeName="d"
                                values="
                                    M 80.288513,108.33648 C 50.421468,63.548977 28.173847,30.649382 2.6261946,30.74767;
                                    M 80.344442,108.46436 C 39.224761,94.86222 14.888674,67.750568 2.6821236,30.875556;
                                    M 80.288513,108.33648 C 50.421468,63.548977 28.173847,30.649382 2.6261946,30.74767
                                "
                                dur="7s"
                                repeatCount="indefinite"
                                begin="0" />
                        </path>
                        <path
                            d="M 2.6261946,30.74767 C 17.402303,41.603797 41.843053,42.2314 41.372563,69.223664 c 0.12726,9.966605 23.7341,28.616776 38.91595,39.112816"
                            style={this.getPathStyle(thirdSecondaryColor)}
                        >
                            <animate
                                attributeName="d"
                                values="
                                    M 2.6261946,30.74767 C 17.402303,41.603797 41.843053,42.2314 41.372563,69.223664 c 0.12726,9.966605 23.7341,28.616776 38.91595,39.112816;
                                    M 2.6821236,30.875557 C 16.035579,42.493128 -4.0692779,58.60244 35.705479,64.054306 65.510136,68.999241 53.405467,82.25545 80.344442,108.46437;
                                    M 2.6261946,30.74767 C 17.402303,41.603797 41.843053,42.2314 41.372563,69.223664 c 0.12726,9.966605 23.7341,28.616776 38.91595,39.112816
                                "
                                dur="4s"
                                repeatCount="indefinite"
                                begin="0" />
                        </path>
                    </g>

                    <g
                        id={'andra-glyph-triangle-' + this.state.id}
                    >
                        <path
                            d="M 2.6821236,30.875556 108.51532,2.7557794"
                            style={this.getTriangleStyle(this.state.colors[index1])}
                        />
                        <path
                            d="M 108.58544,2.7557834 80.344442,108.46437"
                            style={this.getTriangleStyle(this.state.colors[secondColorMixing ? index1 : index2])}
                        />
                        <path
                            d="M 80.288512,108.33648 2.6821236,30.875556"
                            style={this.getTriangleStyle(this.state.colors[index3])}
                        />
                    </g>
                </svg>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        andra: state.andra,
        language: state.user === null ? TranslationService.getDefaultLanguage() : state.user.language
    }
};

export const WavingTriangle = connect(mapStateToProps, { setView })(WavingTriangleClass);